import React from 'react';
import { Leaf } from 'lucide-react';
import { colors, fonts } from '../tokens';
import { EnPowerWordmarkInline } from '../../EnPowerLogo';

const renderFootnote = (footnote) => {
  const text = String(footnote || '');

  if (!text.startsWith('EN:POWER')) {
    return text;
  }

  return (
    <>
      <EnPowerWordmarkInline enColor="#FFFFFF" powerColor={colors.orange} fontFamily={fonts.body} fontSize="8.5px" fontWeight={700} letterSpacing="0" />
      {text.slice('EN:POWER'.length)}
    </>
  );
};

/**
 * QuoteBlock – Highlight-/Zitat-Block in der CompanySection (Page 2).
 */
export const QuoteBlock = ({ quote, footnote }) => (
  <div
    style={{
      background: colors.navy,
      borderRadius: '12px',
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      boxSizing: 'border-box',
    }}
  >
    <Leaf size={20} color={colors.orange} strokeWidth={1.5} />
    <p
      style={{
        fontFamily: fonts.display,
        fontSize: '12.5px',
        fontWeight: 700,
        color: 'white',
        lineHeight: 1.35,
        margin: '10px 0',
      }}
    >
      &bdquo;{quote}&ldquo;
    </p>
    <div>
      <div style={{ width: '28px', height: '2px', background: colors.orange, borderRadius: '1px', marginBottom: '6px' }} />
      <p style={{ fontFamily: fonts.body, fontSize: '8.5px', color: 'rgba(255,255,255,0.5)', lineHeight: 1.4 }}>{renderFootnote(footnote)}</p>
    </div>
  </div>
);
